module.exports = {"pt-BR":{"errors":{"invalid":"Não é válido","missing":"Não pode ficar em branco","taken":"Já está em uso"}}}